"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = {
  root: {
    color: _colors["default"].blue,
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 'normal',
    height: '100%',
    margin: 0,
    padding: '10px 15px',
    borderRight: "1px solid ".concat(_colors["default"].blue),
    borderBottom: 0,
    '&:hover': {
      color: _colors["default"].white,
      background: _colors["default"].blue,
      opacity: function opacity(_ref) {
        var selected = _ref.selected;
        return selected ? 1 : 0.9;
      }
    },
    '&:focus': {
      color: ''
    },
    '&:first-child': {
      borderRadius: '2px 0 0 2px'
    },
    '&:last-child': {
      borderRadius: '0 2px 2px 0',
      borderRight: 'none'
    }
  },
  selected: {
    background: _colors["default"].blue,
    color: _colors["default"].white,
    borderBottom: 0
  }
};
var _default = styles;
exports["default"] = _default;